<div class="table-page table-page--fill">

    <header class="header">
        <div class="title-row">
            <button class="back" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
                <i class="fa fa-arrow-right"></i>
            </button>

            <div class="title-block">
                <h1 class="title">سرویس‌های دوره‌ای</h1>
                <span class="muted">
                    {{ vehicle.owner }} · پلاک {{ otherService.returnCorrectPlate(vehicle.plate) }} · ({{ vehicle.company }})
                </span>
            </div>

            <div class="actions">
                <button class="btn-round" type="button" aria-label="راهنما" (click)="showHelp()"
                    (mouseenter)="showTooltip($event, 'راهنمای سرویس‌های دوره‌ای')" (mouseleave)="hideTooltip()">
                    <i class="fa fa-question"></i>
                </button>

                <button class="btn btn-primary" id="addBtn" type="button" data-bs-toggle="modal"
                    data-bs-target="#exampleModal" (click)="startCreate()">
                    <i class="fa fa-plus"></i> ثبت سرویس
                </button>
            </div>
        </div>
    </header>

    <section class="card" id="card">
        <div class="table-toolbar">
            <div class="search-wrap">
                <input class="control" id="fSearch" placeholder="جستجو در جدول: موضوع، سررسید، تاریخ، کیلومتر..."
                    [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" />
                <i class="fa fa-search"></i>
            </div>

            <div class="toolbar-actions">
                <button class="btn btn-soft" type="button" (click)="printReport()">
                    <i class="fa fa-print"></i> چاپ
                </button>

                <button class="btn btn-soft" type="button" (click)="exportExcel()">
                    <i class="fa fa-file-excel-o"></i> خروجی اکسل
                </button>
            </div>
        </div>

        <div class="body">
            <div class="loader" id="loader" [class.show]="loading" role="status" aria-live="polite">
                <div class="spinner"></div>
                <span>در حال دریافت اطلاعات…</span>
            </div>

            <div class="state" id="stEmpty" [class.show]="!loading && !hasError && filteredRows.length === 0">
                <ng-container *ngIf="searchText.trim(); else noData">
                    <div class="ico-big"><i class="fa fa-search"></i></div>
                    <h4>با این جستجو نتیجه‌ای پیدا نشد!</h4>
                    <span class="muted">عبارت جستجو را در نوار بالای جدول تغییر دهید یا پاک کنید.</span>
                </ng-container>

                <ng-template #noData>
                    <div class="ico-big"><i class="fa fa-inbox"></i></div>
                    <h4>سرویس دوره‌ای برای این خودرو ثبت نشده است</h4>
                    <span class="muted">با دکمه «ثبت سرویس» در بالای صفحه، اولین سرویس را ثبت کنید.</span>
                </ng-template>
            </div>

            <div class="state error" id="stError" [class.show]="hasError">
                <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
                <h4>دریافت اطلاعات با خطا مواجه شد</h4>
                <span class="muted">اتصال به سرور را بررسی و دوباره تلاش کنید.</span>
                <button class="btn btn-primary retry" type="button" id="retryBtn" (click)="loadServices()">
                    <i class="fa fa-refresh"></i> تلاش مجدد
                </button>
            </div>

            <div class="table-scroll" id="tableWrap" (scroll)="hideTooltip()">
                <table>
                    <thead id="thead">
                        <tr>
                            <th class="col-ops sticky-first">عملیات</th>
                            <th class="col-num">#</th>
                            <th>کاربر ثبت‌کننده</th>
                            <th>موضوع</th>
                            <th>سررسید</th>
                            <th>تاریخ</th>
                            <th>کیلومتر</th>
                            <th>وضعیت</th>
                        </tr>
                    </thead>

                    <tbody id="tbody">
                        <tr *ngFor="let row of pagedRows; let i = index; trackBy: trackById">
                            <td class="col-ops sticky-first">
                                <div class="row-ops">
                                    <button class="ico" type="button" aria-label="مشاهده و ویرایش"
                                        (mouseenter)="showTooltip($event, 'ویرایش')" (mouseleave)="hideTooltip()"
                                        (click)="openEditModal(row)">
                                        <i class="fa fa-pencil"></i>
                                    </button>

                                    <button class="ico" type="button" aria-label="حذف"
                                        (mouseenter)="showTooltip($event, 'حذف')" (mouseleave)="hideTooltip()"
                                        (click)="confirmDelete(row)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>

                            <td class="col-num num">{{ (currentPage - 1) * pageSize + i + 1 | faNum }}</td>
                            <td>{{ row.strUserSaved | faNum }}</td>
                            <td>{{ row.strRepairMaintenanceSubject_strComment | faNum }}</td>
                            <td>{{ row.strMaintenanceMaturity_strComment | faNum }}</td>
                            <td>{{ row.strDate | faNum }}</td>
                            <td>{{ row.kmText | faNum }}</td>
                            <td>
                                <span class="tag" [ngClass]="row.statusInfo.tag"
                                    (mouseenter)="showTooltip($event, row.statusInfo.text)"
                                    (mouseleave)="hideTooltip()">
                                    {{ row.statusInfo.label }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length"
            [pageSizeOptions]="pageSizeOptions" (pageChange)="goToPage($event)"
            (pageSizeChange)="onPageSizeChange($event)"></app-table-pagination>
    </section>

    <!-- جدول خروجی چاپ/اکسل: فقط موقع خروجی گرفتن ساخته می‌شود -->
    <div *ngIf="isExporting">
        <div id="print-table-periodicServices" class="print-only">
            <div class="row dirI">
                <div class="col-10 text-center align-items-center border">
                    <p class="mt-2 fw-bold">{{ loggedInUser }}</p>
                    <p>سرویس‌های دوره‌ای {{ vehicle.owner }} با شماره پلاک {{ reversedPlate }} از {{ vehicle.company }}</p>
                </div>
                <div class="col-2 text-center align-items-center border">
                    <p class="p-2">تاریخ تهیه</p>
                    {{ otherService.getCurrentDate() | faNum }}
                </div>
            </div>

            <div class="table-responsive table-striped dirI">
                <table class="table table-striped mt-1 dirI" id="excel-table-periodicServices">
                    <thead>
                        <tr class="text-center">
                            <th scope="col">#</th>
                            <th scope="col">کاربر ثبت کننده</th>
                            <th scope="col">موضوع</th>
                            <th scope="col">سررسید</th>
                            <th scope="col">تاریخ</th>
                            <th scope="col">کیلومتر</th>
                            <th scope="col">وضعیت</th>
                            <th scope="col">VIN</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr class="text-center f14" *ngFor="let row of filteredRows; let i = index">
                            <th class="text-dark">{{ i + 1 | faNum }}</th>
                            <th class="text-dark">{{ row.strUserSaved | faNum }}</th>
                            <th class="text-dark">{{ row.strRepairMaintenanceSubject_strComment | faNum }}</th>
                            <th class="text-dark">{{ row.strMaintenanceMaturity_strComment | faNum }}</th>
                            <th class="text-dark">{{ row.strDate | faNum }}</th>
                            <th class="text-dark">{{ row.kmText }}</th>
                            <th class="text-dark">{{ row.statusInfo.text }}</th>
                            <th class="text-primary">{{ row.strVIN }}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- ===== مودال ثبت / ویرایش ===== -->
    <div class="modal fade rtl" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">سرویس‌های دوره‌ای</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
                </div>

                <div class="modal-body modal-body-scroll">
                    <form [formGroup]="serviceForm" class="row g-3">
                        <div class="col-12 col-md-6">
                            <label class="field">
                                <span class="field-label">نوع تعمیر نگهداری <span class="text-danger">*</span></span>
                                <select class="control" formControlName="iRepairMaintenanceSubject"
                                    [attr.disabled]="isEditMode ? '' : null">
                                    <option *ngFor="let item of subjectOptions" [ngValue]="item.iRepairMaintenanceSubject">
                                        {{ item.strComment }}
                                    </option>
                                </select>
                            </label>
                        </div>

                        <div class="col-12 col-md-6">
                            <label class="field">
                                <span class="field-label">نوع سررسید</span>
                                <select class="control" formControlName="tiMaintenanceMaturity"
                                    [attr.disabled]="isEditMode ? '' : null" (change)="onMaturityChange()">
                                    <option *ngFor="let item of maturityOptions" [ngValue]="item.tiMaintenanceMaturity">
                                        {{ item.strComment }}
                                    </option>
                                </select>
                            </label>
                        </div>

                        <div class="col-12 col-md-6" *ngIf="showKmInput">
                            <label class="field">
                                <span class="field-label">مسافت خدمات به کیلومتر</span>
                                <input type="text" class="control num" formControlName="iKM"
                                    (keypress)="onNumberKeyPress($event)" />
                            </label>
                        </div>

                        <div class="col-12 col-md-6" *ngIf="showWorkHoursInput">
                            <label class="field">
                                <span class="field-label">ساعت خودرو <span class="text-danger">*</span></span>
                                <input type="text" class="control num" formControlName="iWorkHours"
                                    (keypress)="onNumberKeyPress($event)" />
                            </label>
                        </div>

                        <div class="col-12 col-md-6" *ngIf="showDateInput">
                            <div class="field" [formGroup]="dueDateForm">
                                <span class="field-label">تاریخ سررسید <span class="text-danger">*</span></span>
                                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                    [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                    <input type="text" formControlName="date" class="control num" readonly />
                                </ng-persian-datepicker>
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="field">
                                <span class="field-label">توضیحات</span>
                                <textarea class="control" formControlName="strComment" placeholder="توضیحات"></textarea>
                            </label>
                        </div>
                    </form>
                </div>

                <div class="modal-footer">
                    <div class="modal-footer-split w-100">
                        <div class="footer-main-actions">
                            <button type="button" class="btn btn-ghost" data-bs-dismiss="modal">بستن</button>

                            <button type="button" class="btn btn-primary" (click)="saveService()" *ngIf="!isEditMode">
                                ذخیره
                            </button>

                            <button type="button" class="btn btn-primary" (click)="updateService()" *ngIf="isEditMode">
                                ویرایش
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== تولتیپ شناور ===== -->
    <div class="tooltip" role="tooltip" [class.show]="tooltip.visible"
        [style.left.px]="tooltip.x" [style.top.px]="tooltip.y">
        {{ tooltip.text }}
    </div>

</div>
